import { createContext, useContext } from 'react';

import type { TruncationMode } from '@dynatrace/strato-components/typography';

import { DEFAULT_TRUNCATION_MODE } from '../constants.js';

export const RangeLegendTruncationContext = createContext<TruncationMode>(
  DEFAULT_TRUNCATION_MODE,
);

export const useRangeLegendTruncation = () =>
  useContext(RangeLegendTruncationContext);
